var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-bf",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de0000",
    d: "M640 479.6H.4V0H640z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#35a100",
    d: "M639.6 480H0V240.2h639.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff300",
    d: "m254.6 276.2-106-72.4h131L320 86.6 360.4 204l131-.1-106 72.4 40.5 117.3-106-72.6L214 393.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBf);
export default __webpack_public_path__ + "static/media/bf.a3957b0a.svg";
export { ForwardRef as ReactComponent };